module.exports = __webpack_public_path__ + "img/stock.d4502e51.png";